import { apiClient } from '@/lib/api/api-client'
import type { LogEntry } from '@/types/log'
import type { Repair, RepairDetail } from '../types/repair'

const REPAIRS_ENDPOINT = '/repairs'

type CreateRepairPayload = {
  itemId: string
  title: string
  description: string
  priority: string
  imageIds?: string[]
}

type UpdateRepairStatusPayload = {
  status: string
  estimatedCompletion?: string
  imageIds?: string[]
  technicianNote?: string
}

type CompleteRepairPayload = {
  imageIds?: string[]
  technicianNote?: string
}

type AssignRepairPayload = {
  technicianId: string
}

export const repairApi = {
  createRepair: (payload: CreateRepairPayload) => apiClient.post<Repair>(REPAIRS_ENDPOINT, payload),

  getRepairs: (params?: { status?: string }) => apiClient.get<Repair[]>(REPAIRS_ENDPOINT, { params }),

  getRepair: (id: string) => apiClient.get<RepairDetail>(`${REPAIRS_ENDPOINT}/${id}`),

  getRepairLogs: (id: string) => apiClient.get<LogEntry[]>(`${REPAIRS_ENDPOINT}/${id}/logs`),

  acknowledgeRepair: (id: string) => apiClient.patch<Repair>(`${REPAIRS_ENDPOINT}/${id}/acknowledge`, {}),

  updateRepairStatus: (id: string, payload: UpdateRepairStatusPayload) =>
    apiClient.patch<Repair>(`${REPAIRS_ENDPOINT}/${id}/update-status`, payload),

  completeRepair: (id: string, payload?: CompleteRepairPayload) =>
    apiClient.patch<Repair>(`${REPAIRS_ENDPOINT}/${id}/complete`, payload),

  assignRepair: (id: string, payload: AssignRepairPayload) =>
    apiClient.patch<Repair>(`${REPAIRS_ENDPOINT}/${id}/assign`, payload),
}
